/* eslint-disable @typescript-eslint/no-explicit-any */
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

interface CategorySort {
  onChange: (
    e: { name: string; value: string | null }[],
    routerChange?: boolean
  ) => void
  className?: string
  sortOptions: any
  activeSort: any
  activeSortCustom: string[]
}

const CategorySort = ({
  sortOptions,
  onChange = () => true,
  className = '',
  activeSort = '',
  activeSortCustom = [],
}: CategorySort) => {
  const router = useRouter()
  const [selectedSort, setSelectedSort] = useState<{
    type: string
    name: string
  } | null>(null)

  useEffect(() => {
    setSelectedSort(null)
  }, [router.asPath])

  useEffect(() => {
    if (activeSortCustom.length > 0) {
      setSelectedSort({ type: 'custom', name: activeSortCustom[0] })
    } else if (activeSort) {
      setSelectedSort({ type: 'sortType', name: activeSort })
    } else {
      setSelectedSort(null)
    }
  }, [activeSort, activeSortCustom])

  const onChangeSortCustom = (by: any) => {
    if (selectedSort?.type === 'custom' && selectedSort.name === by.name) {
      setSelectedSort(null)
      const resetArray = sortOptions
        .filter((e: any) => e.type === 'custom')
        .map((item: any) => ({ name: item.name, value: null }))
      onChange(
        [
          ...resetArray,
          { name: 'sortBy', value: null },
          { name: 'sortType', value: null },
        ],
        true
      )
    } else {
      setSelectedSort({ type: 'custom', name: by.name })
      const updatedArray = sortOptions
        .filter((e: any) => e.type === 'custom')
        .map((item: any) => ({
          name: item.name,
          value: item.name === by.name ? true : null,
        }))
      onChange(
        [
          ...updatedArray,
          { name: 'sortBy', value: null },
          { name: 'sortType', value: null },
        ],
        true
      )
    }
  }

  const onPriceSort = (name: string) => {
    if (selectedSort?.type === 'sortType' && selectedSort.name === name) {
      setSelectedSort(null)
      return onChange(
        [
          { name: 'sortBy', value: null },
          { name: 'sortType', value: null },
        ],
        true
      )
    }

    setSelectedSort({ type: 'sortType', name })
    const resetCustom = sortOptions
      .filter((e: any) => e.type === 'custom')
      .map((item: any) => ({ name: item.name, value: null }))

    return onChange(
      [
        ...resetCustom,
        { name: 'sortBy', value: 'calMediaPrice' },
        { name: 'sortType', value: name },
      ],
      true
    )
  }

  return (
    <div className={`w-full ${className}`}>
      <div className='catSort flex mt-2 gap-2 justify-start whitespace-nowrap overflow-x-auto overflow-y-hidden'>
        {sortOptions
          .filter((item: any) => item.type === 'custom')
          .map((e: any, idx: number) => (
            <button
              key={`sort-cus-${idx}`}
              onClick={() => onChangeSortCustom(e)}
            >
              <div
                className={`flex h-[30px] cursor-pointer items-center px-2 ${
                  selectedSort?.type === 'custom' &&
                  selectedSort.name === e.name
                    ? 'bg-[#FFF0F1] text-[#F00000] rounded-[60px]'
                    : ''
                }`}
              >
                {e.label}
              </div>
            </button>
          ))}

        {sortOptions
          .filter((item: any) => item.type === 'sortType')
          .map((e: any, idx: number) => (
            <button
              key={`sort-type-${idx}`}
              onClick={() => onPriceSort(e.name)}
            >
              <div
                className={`flex h-[30px] cursor-pointer items-center px-2 ${
                  selectedSort?.type === 'sortType' &&
                  selectedSort.name === e.name
                    ? 'bg-[#FFF0F1] text-[#F00000] rounded-[60px]'
                    : ''
                }`}
              >
                {e.label}
              </div>
            </button>
          ))}
      </div>
    </div>
  )
}

export default CategorySort
